module.exports = __webpack_public_path__ + "assets/3e21473fd02443a1d9254a5ade2e6f6b.png";